export default __webpack_public_path__ + "static/media/card1600.0ed93609.jpg";